import { FunctionComponent, useCallback } from 'react';

import CaretIcon from '@/components/icons/Caret';
import RewindIcon from '@/components/icons/Rewind';
import SbsIcon from '@/components/icons/SBS';
import { useRevealJsContext } from '@/providers/RevealJsProvider';

const Welcome: FunctionComponent<RewindSlideProps> = (props) => {
  const { active } = props;
  const { sdk } = useRevealJsContext();

  const handleSlideDownClick = useCallback(() => {
    if (sdk) {
      sdk.down();
    }
  }, [sdk]);

  return (
    <>
      <div aria-label="SBS Rewind">
        <div
          className="flex flex-col items-center
          h-[calc(39px+4vw)] lg:h-[102px] mt-[-180px]
          slide-in-from-left"
        >
          <SbsIcon/>
        </div>
        <div
          className="flex flex-col items-center
          h-[calc(41px+4vw)] lg:h-[110px] mt-[20px] lg:mt-[34px]
          slide-in-from-right"
        >
          <RewindIcon/>
        </div>
      </div>
      <p
        className="text-base absolute px-8
          bottom-[20vh] slide-up delay-[600ms]"
      >
        Scroll down to discover your streaming trends for 2023
      </p>
      <div
        className="absolute flex-col items-center
         bottom-[8vh] slide-down delay-[900ms]
         animate-bounce"
      >
        <button type="button" onClick={handleSlideDownClick} tabIndex={active ? 0 : -1}>
          <CaretIcon/>
        </button>
      </div>
    </>
  );
};

export default Welcome;
